export default __webpack_public_path__ + "static/media/CovidTrackerProvincePage.a229bde1.PNG";